export const errorResponseTransform = (errors = []) =>
  errors.reduce(
    (result, { field, message }) => ({
      ...result,
      [field]: message,
    }),
    {},
  );
